<section fxLayout="column" class="h-100">
    <section fxLayout="column" fxFlex="1 1 auto" class="m-auto w-75 overflow-hidden py-4">
        <div fxLayout="row" fxLayoutAlign="space-between center" class="sen-ac-dc">
            <mat-checkbox [(ngModel)]="panelConnector"> {{translate.getLng('MOD_CON')}}</mat-checkbox>
            <mat-form-field *ngIf="acDcData?.dcSurgeProtect" class="w-50" floatLabel="always">
                <mat-label>{{translate.getLng('DC_OV_SEC')}}</mat-label>
                <mat-select [(ngModel)]="surgeProtect" [placeholder]="translate.getLng('CHOOSE_OPTION')">
                    <mat-option value="">{{translate.getLng('CHOOSE_OPTION')}}</mat-option>
                    <mat-option *ngFor="let s of acDcData.dcSurgeProtect" title="{{s.name}}" [value]="s.senItemID">
                        {{s.name | truncate:40}} ({{s.price}} &euro;)
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </div>
        <div>
            <h4>{{translate.getLng('DC_CABLE')}} - <span *ngIf="acDcData?.dcCable"
                    class="sen-fs12">{{acDcData.dcCable.name}}</span></h4>
            <div class="w-60">
                <label>{{translate.getLng('DC_CABLE_LENGTH')}}</label>
                <mat-form-field class="mx-3 w-25">
                    <input type="number" mask="0000" class="text-right" [(ngModel)]="globalLength" min="1" matInput>
                    <span matSuffix>{{translate.getLng('UNIT_M')}}</span>
                </mat-form-field>
                <button mat-raised-button (click)="setGlobalLength()" color="primary" class="px-3">
                    {{translate.getLng('OK')}}
                </button>
            </div>
        </div>
        <div class="sen-info-color-bg p-3 mb-2 overflow-auto" fxFlex="1 1 auto">
            <table mat-table #acdcCable class="w-100" [dataSource]="dataSource">
                <ng-container matColumnDef="SubGen">
                    <th mat-header-cell *matHeaderCellDef> {{translate.getLng('SUB_GENERATOR')}} </th>
                    <td mat-cell *matCellDef="let element"> {{element.SubGen}} </td>
                </ng-container>
                <ng-container matColumnDef="StrCnt">
                    <th mat-header-cell *matHeaderCellDef> {{translate.getLng('STRING_COUNT')}} </th>
                    <td mat-cell *matCellDef="let element"> {{element.StrCnt}} </td>
                </ng-container>
                <ng-container matColumnDef="length">
                    <th mat-header-cell *matHeaderCellDef> {{translate.getLng('LENGTH')}}

                    </th>
                    <td mat-cell *matCellDef="let element; let i = index">
                        <mat-form-field class="sen-number-input text-right font-weight-bold sen-fs10" fxFlex="1 1 20%">
                            <input type="number" (input)="calculateTotalAndLoss(element, i)"
                                [(ngModel)]="element.length" min="1" [value]="element.length" matInput>
                        </mat-form-field> {{translate.getLng('UNIT_M')}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="total">
                    <th mat-header-cell *matHeaderCellDef>{{translate.getLng('TOTAL')}} </th>
                    <td mat-cell *matCellDef="let element">{{element.total}} {{translate.getLng('UNIT_M')}}</td>
                </ng-container>
                <ng-container matColumnDef="loss">
                    <th mat-header-cell *matHeaderCellDef>{{translate.getLng('LOSS_STRING')}} </th>
                    <td mat-cell *matCellDef="let element">{{convertToLocalNumber(element.loss | number : '1.2-2')}}
                        {{translate.getLng('UNIT_W')}} </td>
                </ng-container>
                <ng-container matColumnDef="pCount">
                    <th [hidden]="true" mat-header-cell *matHeaderCellDef></th>
                    <td [hidden]="true" mat-cell *matCellDef="let element"> </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
    </section>
    <div class="m-3" fxLayout="row" fxLayoutAlign="flex-end center">
        <button mat-raised-button class="px-5 py-2" color="primary"
            [routerLink]="[prevPath]">{{translate.getLng('PREV')}}</button>
        <button mat-raised-button class="px-5 py-2 ml-2" color="primary"
            [matMenuTriggerFor]="menu">{{translate.getLng('SAVE')}}
            <mat-icon class="pl-4">keyboard_arrow_up</mat-icon>
        </button>
        <mat-menu #menu="matMenu" yPosition="above">
            <button mat-menu-item class="sen-fs10"
                (click)="saveInverterPlan(managePath)">{{translate.getLng('SAVE_PROCEED_TO_MANAGE')}}</button>
            <button mat-menu-item class="sen-fs10"
                (click)="saveInverterPlan(itemPath)">{{translate.getLng('SAVE_PROCEED_TO_ITEM')}}</button>
        </mat-menu>
    </div>
</section>